var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80273 11.2669V15.4175H5.50626C5.93556 15.416 6.36239 15.4816 6.77093 15.6118L7.60774 15.8807C8.26001 16.0875 8.9408 16.1934 9.62592 16.1946H16.1235C16.3641 16.1945 16.596 16.1055 16.7733 15.945C16.9507 15.7846 17.0606 15.5643 17.0814 15.3278L17.994 8.4799C18.0065 8.39138 17.9995 8.30124 17.9736 8.2156C17.9477 8.12995 17.9035 8.05079 17.8439 7.98349C17.7843 7.91618 17.7107 7.86229 17.6281 7.82547C17.5456 7.78866 17.456 7.76977 17.3654 7.77008H13.1208C13.008 7.7691 12.9001 7.72419 12.8207 7.64512C12.7413 7.56606 12.6967 7.45924 12.6967 7.34792V4.17614C12.6967 4.06151 12.6738 3.94801 12.6292 3.84216C12.5846 3.73631 12.5193 3.64018 12.437 3.5593C12.3547 3.47842 12.257 3.41438 12.1495 3.37086C12.042 3.32733 11.9269 3.30518 11.8107 3.30567H10.3529L8.60736 7.27321C8.48973 7.54078 8.31935 7.78262 8.10614 7.98464C7.89293 8.18667 7.64114 8.34486 7.36541 8.45002L6.64977 8.72274C6.25308 8.87147 5.83217 8.94744 5.40781 8.94689H2",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export default ForwardRef;